module.exports = __webpack_public_path__ + "static/img/wfv_logo.351ffb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wfv_logo.png
// module id = WF5k
// module chunks = 12